//@ts-strict-ignore
import React from 'react';
import { ProgressIndicator } from '@fluentui/react/lib/ProgressIndicator';
import { BasicHeader } from '../../actions/BasicHeader';

const SuspenseFallback = () => {
  return (
    <>
      <BasicHeader />
      <ProgressIndicator />
    </>
  );
};

export default SuspenseFallback;
